import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login({ onSwitch }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email || !password) { setError('Please fill in all fields.'); return; }
    try {
      setError(''); setLoading(true);
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      const c = err.code;
      if (c==='auth/user-not-found'||c==='auth/wrong-password'||c==='auth/invalid-credential'||c==='auth/invalid-email')
        setError('Invalid email or password. Please try again.');
      else if (c==='auth/too-many-requests')
        setError('Too many attempts. Please wait a moment and try again.');
      else setError('Sign in failed. Please try again.');
    } finally { setLoading(false); }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-panel-left">
        <div className="left-logo">
          <div className="left-logo-icon">L</div>
          <span className="left-logo-name">Lend Pesa</span>
        </div>
        <h2 className="left-headline">Fast Loans,<br />Zero Hassle.</h2>
        <p className="left-sub">Get approved in minutes. Funds sent directly to your M-Pesa — no paperwork, no guarantors.</p>
        <div className="left-stats">
          {[
            { icon:'⚡', text:'Instant Approval',       sub:'Decision in under 2 minutes' },
            { icon:'📱', text:'M-Pesa Disbursement',    sub:'Funds within 24 hours' },
            { icon:'🛡️', text:'CBK Licensed & Secure', sub:'256-bit SSL encryption' },
            { icon:'✅', text:'No CRB Check',           sub:'Everyone qualifies' },
          ].map(s => (
            <div className="stat-pill" key={s.text}>
              <div className="stat-pill-icon">{s.icon}</div>
              <div>
                <div className="stat-pill-text">{s.text}</div>
                <div className="stat-pill-sub">{s.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="auth-panel-right">
        <div className="auth-form-wrap">
          <div className="auth-form-logo">
            <div className="auth-form-logo-icon">L</div>
            <span className="auth-form-logo-name">Lend Pesa</span>
          </div>
          <h2 className="auth-form-title">Welcome back 👋</h2>
          <p className="auth-form-sub">Sign in to access your loan dashboard</p>

          {error && <div className="alert-err"><span>⚠️</span>{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="field-group">
              <label className="field-label">Email Address</label>
              <input type="email" className="field-input" placeholder="john@example.com"
                value={email} onChange={e => setEmail(e.target.value)} required />
            </div>
            <div className="field-group">
              <label className="field-label">Password</label>
              <input type="password" className="field-input" placeholder="Enter your password"
                value={password} onChange={e => setPassword(e.target.value)} required />
            </div>
            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? <><span className="mini-spin"></span>Signing in…</> : 'Sign In →'}
            </button>
          </form>

          <div className="auth-switch">Don't have an account? <a onClick={onSwitch}>Create account</a></div>
          <div className="trust-chips">
            <span className="trust-chip">🔒 Secure & Encrypted</span>
            <span className="trust-chip">✅ CBK Licensed</span>
            <span className="trust-chip">📱 M-Pesa Ready</span>
          </div>
        </div>
      </div>
    </div>
  );
}
